import { createContext } from 'react';
/**
 * Context providing a {@link WorkerVariablesStore} that delivers push-based,
 * ref-counted worker variable lists. `null` when the host does not expose
 * field-update subscriptions; consumers must handle the missing-provider case.
 */
export var WorkerVariablesContext = /*#__PURE__*/createContext(null);
WorkerVariablesContext.displayName = 'WorkerVariablesContext';
export default WorkerVariablesContext;
//# sourceMappingURL=WorkerVariablesContext.js.map